import { CHART_COLORS } from 'Constants';
import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import '../styles.css';

import { useDashboardContext } from 'Components/Dashboard/context';

export default function ChartProjects() {
  const { mainOverviewData, mainOverviewFilterParams } = useDashboardContext();
  const periodType = mainOverviewFilterParams.periodType;
  const data = mainOverviewData?.projectsOverview;

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={400}
        height={340}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 25,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey={periodType === 'yearly' ? 'year' : 'quarter'}
          label={{
            className: 'noselect',
            position: 'bottom',
          }}
        />
        <YAxis
          label={{
            value: 'Amount of Projects',
            angle: -90,
            position: 'insideBottomLeft',
            className: 'noselect',
          }}
        />
        <Tooltip
          labelFormatter={(_, payload) => {
            try {
              const name =
                payload[0].payload[
                  periodType === 'yearly' ? 'year' : 'quarter'
                ];
              return name;
            } catch (err) {
              return '';
            }
          }}
          formatter={(value) => {
            return [value, 'Projects'];
          }}
        />
        <Bar dataKey="value" stackId="a" fill={CHART_COLORS[0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
